// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1Nf-z","question":"Question_question__3YqQT","description":"Question_description__Tfrc8"};